import { deleteActions, patchActions, postActions } from "../const/logActions";
import { CheckActions } from "../types/checkAuth";

const checkActions: CheckActions = (reqType, url) => {
  switch (reqType) {
    case "DELETE":
      const deleteRes = deleteActions.find((el) => url?.includes(el.path));
      if (!deleteRes) {
        return undefined;
      }
      return deleteRes.actions;
    case "PATCH":
      const patchRes = patchActions.find((el) => url?.includes(el.path));
      if (!patchRes) {
        return undefined;
      }
      return patchRes.actions;
    case "POST":
      const postRes = postActions.find((el) => url.includes(el.path));
      if (!postRes) {
        return undefined;
      }
      return postRes.actions;
    default:
      return undefined;
  }
};

export default checkActions;
